import ReactGA from 'react-ga'
/* eslint-disable no-undef */
const isProd = process.env.REDUX_ENV === 'production'
const isStaging = process.env.REDUX_ENV === 'staging'
const notSnap = navigator.userAgent !== 'ReactSnap'
/* eslint-enable no-undef */

function trackPage(path) {
  const trackingCode = isProd ? 'UA-70255508-6' : isStaging ? 'UA-70255508-3' : ''
  if (notSnap && isProd) {
    ReactGA.initialize(trackingCode)
    ReactGA.pageview(path)
  }
}

export default trackPage
